<p-card
	[header]="controller.baseI18 + 'profile' | translate"
	styleClass="h-full"
>
	<div [formGroup]="form" class="space-y-3 flex flex-col h-full">
		<div class="flex flex-col space-y-1 items-stretch">
			<label>{{ controller.baseI18 + 'firstName.label' | translate }}</label>
			<input
				[placeholder]="controller.baseI18 + 'firstName.placeHolder' | translate"
				formControlName="firstName"
				pInputText
				type="text"
			/>
		</div>
		<div class="flex flex-col space-y-1 items-stretch">
			<label>{{ controller.baseI18 + 'lastName.label' | translate }}</label>
			<input
				[placeholder]="controller.baseI18 + 'lastName.placeHolder' | translate"
				formControlName="lastName"
				pInputText
				type="text"
			/>
		</div>
		<div class="flex flex-col space-y-1 items-stretch">
			<label>{{ controller.baseI18 + 'phoneNumber.label' | translate }}</label>
			<input
				[placeholder]="controller.baseI18 + 'phoneNumber.placeHolder' | translate"
				formControlName="phoneNumber"
				pInputText
				type="text"
			/>
		</div>
		<div class="flex items-start space-x-3">
			<div class="flex flex-1 flex-col space-y-1 items-stretch overflow-hidden">
				<label class="truncate">
					{{ controller.baseI18 + 'birthDate.label' | translate }}
				</label>
				<p-calendar
					[locale]="controller.calendarLocale$ | async"
					[monthNavigator]="true"
					[placeholder]="controller.baseI18 + 'birthDate.placeHolder' | translate"
					[readonlyInput]="false"
					[yearNavigator]="true"
					[yearRange]="birthDateRange"
					appendTo="body"
					dateFormat="dd/mm/yy"
					formControlName="birthDate"
					inputStyleClass="w-full"
					styleClass="w-full"
				></p-calendar>
			</div>
			<div class="flex flex-1 flex-col space-y-1 items-stretch overflow-hidden">
				<label class="truncate">
					{{ controller.baseI18 + 'originAddress.label' | translate }}
				</label>
				<input
					[placeholder]="
						controller.baseI18 + 'originAddress.placeHolder' | translate
					"
					formControlName="originAddress"
					pInputText
					type="text"
				/>
			</div>
		</div>
		<div class="flex items-start space-x-3">
			<div class="flex flex-1 flex-col space-y-1 items-stretch overflow-hidden">
				<label class="truncate">
					{{ controller.baseI18 + 'livingAddress.label' | translate }}
				</label>
				<input
					[placeholder]="
						controller.baseI18 + 'livingAddress.placeHolder' | translate
					"
					formControlName="livingAddress"
					pInputText
					type="text"
				/>
			</div>
			<div class="flex flex-1 flex-col space-y-1 items-stretch overflow-hidden">
				<label class="truncate">
					{{ controller.baseI18 + 'timeZone.label' | translate }}
				</label>
				<p-dropdown
					[filter]="true"
					[itemSize]="30"
					[options]="timeZoneOptions"
					[placeholder]="controller.baseI18 + 'timeZone.placeHolder' | translate"
					[virtualScroll]="true"
					appendTo="body"
					formControlName="timeZone"
					styleClass="w-full"
				></p-dropdown>
			</div>
		</div>
		<div class="flex flex-col space-y-1 items-stretch">
			<label>
				{{ controller.baseI18 + 'linkedInUrl.label' | translate }}
			</label>
			<input
				[placeholder]="controller.baseI18 + 'linkedInUrl.placeHolder' | translate"
				formControlName="linkedInUrl"
				pInputText
				type="text"
			/>
		</div>
		<div class="flex flex-1 items-end justify-end">
			<p-progressSpinner
				*ngIf="controller.isSavingInformation$ | async; else save"
				[style]="{ width: '25px', height: '25px' }"
			></p-progressSpinner>
			<ng-template #save>
				<button
					[disabled]="controller.informationFormInvalid$ | async"
					[label]="controller.baseI18 + 'save.label' | translate"
					(click)="onSaveClick()"
					pButton
				></button>
			</ng-template>
		</div>
	</div>
</p-card>
